export default function SvgRight2() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        cursor="pointer"
        fill="#fff"
        data-name="Layer 2"
        viewBox="0 0 32 32"
        >
      <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
      </svg>
    </>
  );
}
